import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dashboardAPI } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { ShieldAlert, ChevronRight } from 'lucide-react';

// Widget Dashboard : compteur des dossiers non sécurisés (sans prochaine action).
// Visibilité gérée côté backend (apporteur = ses dossiers, VP = équipe, admin = tous).
export function UnsecuredProspectsWidget() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const res = await dashboardAPI.getUnsecuredProspects();
                setTotal(res.data?.total || 0);
            } catch (e) {
                console.error('unsecured widget error', e);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <Card
            className="cursor-pointer hover:shadow-lg transition-all duration-200 border-l-4 border-l-amber-500 hover:scale-[1.01]"
            onClick={() => navigate('/dossiers-a-relancer')}
            data-testid="unsecured-prospects-widget"
        >
            <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm text-slate-500">Dossiers à relancer</p>
                        <p className="text-3xl font-bold text-amber-600" data-testid="unsecured-widget-count">{loading ? '...' : total}</p>
                        <p className="text-xs text-slate-400 mt-1">Sans prochaine action planifiée</p>
                    </div>
                    <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
                        <ShieldAlert className="w-6 h-6 text-amber-600" />
                    </div>
                </div>
                <p className="text-xs text-amber-600 mt-3 flex items-center">
                    <ChevronRight className="w-4 h-4" />
                    Cliquer pour voir la liste
                </p>
            </CardContent>
        </Card>
    );
}

export default UnsecuredProspectsWidget;
